import logo from '../assets/logo.svg';
import Lottie from 'react-lottie';
import doctorAnimationData from '../assets/doctor-animation.json';
import tooth from '../assets/tooth.png';
import profile from '../assets/profile.png';
import { Star } from 'react-bootstrap-icons';
import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Header from './Header';

gsap.registerPlugin(ScrollTrigger);

function Home() {
  useEffect(() => {
    gsap.fromTo('.landing-logo', {
      opacity: 1,
    }, {
      opacity: 0,
      ease: 'power1.inOut',
      scrollTrigger: {
        trigger: '#landing',
        start: '60% center',
        end: '70% center',
        scrub: true,
      },
    });
  }, []);

  const lottieDefaultOptions = {
    loop: true,
    autoplay: true,
    animationData: doctorAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className="Home">
      <Header backgroundEffect authButton sticky />
      <section id='landing'>
        <div className='container-fluid'>
          <div className="row landing-row">
            <div className="col-md-6 px-5 d-flex align-items-center">
              <div className='pe-4'>
                <img src={logo} alt="sb-dt" className='img-fluid landing-logo' />
                <h1 className="mt-3">Fedezd fel lenyűgöző fogtechnikusi dizájnereinket</h1>
                <h2>Kreativitásukkal és szakértelmükkel bármikor rendelkezésedre állnak!</h2>
                <img src={tooth} alt='' className='img-fluid tooth d-none d-lg-flex' />

                <div className='d-flex justify-content-center mt-5'>
                  <div className='row demo-profiles'>
                    <div className='col-6 col-lg-4'>
                      <div className='profile'>
                        <img src="https://hatscripts.github.io/circle-flags/flags/hu.svg" className='flag' alt='hu' />
                        <img src={profile} alt='profile' className='img-fluid' />
                      </div>
                      <p className='text-center pt-4'>Zoltan Kovacs</p>
                      <p className='text-secondary d-flex align-items-center justify-content-center'>5.0 <Star className='mx-1' /> Hungary</p>
                    </div>

                    <div className='col-6 col-lg-4'>
                      <div className='profile'>
                        <img src="https://hatscripts.github.io/circle-flags/flags/au.svg" className='flag' alt='au' />
                        <img src={profile} alt='profile' className='img-fluid' />
                      </div>
                      <p className='text-center pt-4'>Liam Foster</p>
                      <p className='text-secondary d-flex align-items-center justify-content-center'>4.2 <Star className='mx-1' /> Australia</p>
                    </div>

                    <div className='d-none d-lg-inline col-lg-4'>
                      <div className='profile'>
                        <img src="https://hatscripts.github.io/circle-flags/flags/fr.svg" className='flag' alt='fr' />
                        <img src={profile} alt='profile' className='img-fluid' />
                      </div>
                      <p className='text-center pt-4'>Amelie Dubois</p>
                      <p className='text-secondary d-flex align-items-center justify-content-center'>4.5 <Star className='mx-1' /> France</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-none d-md-flex col-md-6 bg-dark">
              {/* TODO: Place video here in muted and repeat form */}
            </div>
          </div>
        </div>
      </section>

      <div className='container-fluid'>
        <div className='row bottom-line'>
          <div className='col-12'>
            <p className='mt-2 pt-1 text-center'>Regisztrálj most! December végéig nem szükséges jutalékot fizetni.</p>
          </div>
        </div>
      </div>

      <section id="informations">
        <div className='container'>
          <div className='row'>
            <div className='col-12 d-md-none pt-5'>
              <h1>Még több információ</h1>
            </div>
          </div>

          <div className='row gx-5'>
            <div className='col-md-6 pt-5'>
              <h2>Közösség</h2>
              <p>Ez a közösségi oldal a fogtechnikai dizájnereket és a laboratóriumokat köti össze a világ bármely pontján.</p>
            </div>
            <div className='d-none d-md-flex col-md-6 pt-5'>
              <h1>Még több információ</h1>
            </div>
          </div>

          <div className='row gx-5'>
            <div className='col-md-6 pt-5'>
              <h2>Globális piac</h2>
              <p>A laboratórium globális munkaerővel rendelkezzen, költséghatékonyan és kihasználva az időzónák közti különbséget még a gyorsaságot is tudja növelni ( a világban valahol épp lejár a munkaídőd , de valahol akkor kezdődik)</p>
              <p>A dizájnerek nincsenek helyhez kötve, lehetsz bárhol a világban és közben mégis tudsz dolgozni, ez elképzelhetetlen volt a fogtechnikában eddig, de most eljött ennek is az ideje</p>
            </div>
            <div className='col-md-6 pt-5'>
              <h2>Előnyei a laboratórium részére:</h2>
              <ul>
                <li>tervezők portfoliói alapján választhatsz</li>
                <li>tervezők értékelése segít a döntésben</li>
                <li>preferált tervezőket lehet gyűjteni</li>
                <li>időzónák által generált előnyök</li>
                <li>globális munkaerővel rendelkezhetsz</li>
                <li>Biztonságot nyújt a pénzügyi tranzakcióban mindkét fél számára</li>
                <li>a vállalkozás költségoptimalizálása</li>
                <li>biztosított kommunikáció</li>
              </ul>
            </div>
          </div>

          <div className='row gx-5'>
            <div className='col-md-6 pt-5 stock-div'>
              <Lottie
                options={lottieDefaultOptions}
                height={300}
                width={300}
              />
            </div>
            <div className='col-md-6 pt-5 d-flex align-items-center'>
              <div>
                <h2>Előnyök dizájnerek:</h2>
                <ul>
                  <li>nem helyhez kötött munkavégzés</li>
                  <li>globális piactér</li>
                  <li>önálló időbeosztás</li>
                  <li>önálló munkamennyiség beosztás</li>
                  <li>önálló árszabás</li>
                  <li>átadott munka kifizetésének biztosítása</li>
                  <li>biztosított kommunikáció</li>
                </ul>
              </div>
            </div>
          </div>

          <div className='row pb-5 gx-5'>
            <div className='col-md-6 pt-5'>
              <h2>Egyszerű fizetés</h2>
              <p>A fizetéssel nem kell többet bajlódnod, az általad elkészített dizájnt folyamatosan láthatja a megrendelő és kommunikálhattok is, de a gyártható fájl csak a pénzügyi tranzakció bekövetkeztével lesz elérhető számára. A fizetést és a fájl elérhetőségét az oldalon működő rendszer biztosítja.</p>
            </div>
          </div>
        </div>
      </section >
    </div >
  );
}

export default Home;